<div class="modal-header">
    <h4 class="modal-title">
        Liste des utilisateurs
    </h4>
</div>
<div class="modal-body">

    <form [formGroup]="searchForm">
        <input type="text" class="form-control mb-3" placeholder="Rechercher par nom ou prénom" formControlName="search"
            (keyup.enter)="onSearch()">
    
        <div class="row">
            <div class="form-group col-md-6">
                <select class="form-control mb-3" formControlName="profile">
                    <option value="">Tous les profils</option>
                    <option [value]="profile.id" *ngFor="let profile of profiles">{{ profile.name }}</option>
                </select>
            </div>
            <div class="form-group col-md-6">
                <app-dropdown-select [defaultValue]="formControls.firm.value" formControlName="firm" [apiUrl]="'firms'"
                    [isMultiSelect]="false" [placeHolder]="'Tous les cabinets'" [itemValueKey]="'id'" [itemLabelKey]="'name'"
                    [searchKey]="'name'" [apiFilters]="{'order[name]': 'asc'}" [autoEmitChanges]="true" [hideValidateButton]="true" [clearable]="true" />
            </div>
        </div>
    </form>

    <div class="user-list-container" style="max-height: 420px; overflow-y: auto;">
        <table class="table table-striped table-sm align-middle">
            <thead class="table-light sticky-top">
                <tr>
                    <th>Nom complet</th>
                    <th>Profil</th>
                    <th>Cabinet</th>
                    <th>Mail</th>
                    <th>Utilisateur</th>
                    <th>Cabinet actif</th>
                    <th>Cabinet abonné</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let userFirm of userFirms">
                    <td>{{ userFirm.firstName }} {{ userFirm.lastName }}</td>
                    <td>{{ userFirm.profileName }}</td>
                    <td>{{ userFirm.firmName }}</td>
                    <td>{{ userFirm.email }}</td>
                    <td>
                        <span class="badge" [ngClass]="userFirm.isEnabled ? 'bg-success' : 'bg-secondary'">
                            {{ userFirm.isEnabled ? 'Actif' : 'Inactif' }}
                        </span>
                    </td>
                    <td>
                        <span class="badge" [ngClass]="userFirm.firmIsActive ? 'bg-success' : 'bg-secondary'">
                            {{ userFirm.firmIsActive ? 'Actif' : 'Inactif' }}
                        </span>
                    </td>
                    <td>
                        <span class="badge" [ngClass]="userFirm.firmIsSubscribed ? 'bg-success-subtle text-success-emphasis' : 'bg-danger-subtle text-danger-emphasis'">
                            {{ userFirm.firmIsSubscribed ? 'Oui' : 'Non' }}
                        </span>
                    </td>
                    <td><button class="btn btn-primary btn-sm" (click)="login(userFirm)">Se connecter</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Fermer</button>
</div>
